import { Input } from "component/inputs/Input";
import React, { useCallback } from "react";
import { Field } from "react-final-form";
import "./ConectedDropdown.scss";
import { ConnectedDropdownProps } from "./types";
import { formatHHMM } from "utils/date";
import "../i18n";
import { useTranslation } from "react-i18next";
import { BasicIcon } from "@pickit/pickit-components";
import { SlotsConstants } from "constants/slots";
import classNames from "classnames";

export const ConnectedDropdown: React.FC<ConnectedDropdownProps> = ({
  users,
  testId,
  slot,
  deleteConnectedPicker,
}): JSX.Element => {
  const { t } = useTranslation();
  const renderInput = useCallback(
    (name: string, index: number, value?: string | number) => {
      return (
        <Field
          type="text"
          name={name}
          label={t("slotDetail:" + name + "Label")}
          className="Admin-Pickers-input"
          disabled
          testId={`${testId}-picker-${index + 1}-${name}`}
        >
          {(props) => <Input {...props} value={value} />}
        </Field>
      );
    },
    [t, testId]
  );

  const showRemove =
    slot && SlotsConstants.isCancellableSlot(slot.status.tag);

  const renderUsers = useCallback(() => {
    return users?.map((user, index) => {
      const pickerId = user.pickerId ?? user.id;
      return (
        <div
          key={user.id}
          className={classNames("container-conected-colapsable-form-row", {
            "with-remove": showRemove,
          })}
        >
          <div className="container-conected-colapsable-form-col-sm-1">
            {renderInput("id", index, user.id)}
          </div>
          <div className="container-conected-colapsable-form-col-sm-1">
            {renderInput("name", index, user.name + " " + user.surname)}
          </div>
          <div className="container-conected-colapsable-form-col-sm-1">
            {renderInput("phone", index, user.phone || "-")}
          </div>
          <div className="container-conected-colapsable-form-col-sm-1">
            {renderInput(
              "checkin",
              index,
              user.loginAt ? formatHHMM(user.loginAt) : "-"
            )}
          </div>
          {showRemove && (
            <div className="container-conected-colapsable-form-col-sm-1">
              <div className="button-container">
                <button
                  className="delete-icon"
                  type="button"
                  onClick={() => deleteConnectedPicker(pickerId)}
                  data-testId={`${testId}-picker-${index + 1}-delete`}
                >
                  <BasicIcon name="trash" />
                </button>
              </div>
            </div>
          )}
        </div>
      );
    });
  }, [users, renderInput, showRemove, testId, deleteConnectedPicker]);

  return <div className="connected-dropdown">{renderUsers()}</div>;
};
